/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createUnitFunction } from '../../factoriesAny.js';
export var unitDependencies = {
  UnitDependencies: UnitDependencies,
  typedDependencies: typedDependencies,
  createUnitFunction: createUnitFunction
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesUnitFunction.generated.js
// module id = 1540
// module chunks = 0